import { useEffect, useState } from 'react';
import { getVideoModalWidth } from './videoModalWidth';

// Recomputes the portrait video modal's width on window resize/orientation
// change while it is active, not just when the aspect ratio is first known.
export const useVideoModalWidth = (isActive: boolean, aspectRatio: number | null) => {
  const [width, setWidth] = useState(() => getVideoModalWidth(aspectRatio));

  useEffect(() => {
    if (!isActive) return;

    const updateWidth = () => setWidth(getVideoModalWidth(aspectRatio));

    updateWidth();

    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, [isActive, aspectRatio]);

  return width;
};
